import { render } from "./AddNewStudent.vue?vue&type=template&id=ff5bcebc"
import script from "./AddNewStudent.vue?vue&type=script&lang=js"
export * from "./AddNewStudent.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__